import { makeAutoObservable, runInAction } from 'mobx';
import { request } from '@/common';
class Store {
  // 省级高考信息
  #provinces = [
    {
      city: '上海',
      pici: ['本科普通批', '高职专科批'],
    },
    {
      city: '北京',
      pici: ['本科普通批', '高职专科批'],
    },
    {
      city: '重庆',
      pici: ['本科普通批', '高职专科批'],
    },
    {
      city: '山西',
      pici: ['本科批', '高职专科批'],
    },
    {
      city: '天津',
      pici: ['本科普通批A段', '本科普通批B段', '高职（专科）批'],
    },
    {
      city: '山东',
      pici: ['普通类一段', '普通类二段'],
    },
    {
      city: '河南',
      pici: ['本科批', '高职专科批'],
    },
    {
      city: '湖北',
      pici: ['本科普通批', '专科批'],
    },
    {
      city: '河北',
      pici: ['本科普通批', '高职专科批'],
    },
    {
      city: '江西',
      pici: ['本科普通批', '高职专科批'],
    },
    {
      city: '湖南',
      pici: ['本科普通批', '高职专科批'],
    },
    {
      city: '辽宁',
      pici: ['本科普通批', '高职专科批'],
    },
    {
      city: '吉林',
      pici: ['本科普通批', '高职专科批'],
    },
    {
      city: '黑龙江',
      pici: ['普通本科批', '普通类高职（专科）批'],
    },
    {
      city: '江苏',
      pici: ['本科普通批', '高职专科批'],
    },
    {
      city: '浙江',
      pici: ['普通类平行一段', '普通类平行二段'],
    },
    {
      city: '福建',
      pici: ['本科普通批', '高职专科批'],
    },
    {
      city: '安徽',
      pici: ['本科普通批', '高职（专科）批'],
    },
    {
      city: '广西',
      pici: ['本科普通批', '高职高专普通批'],
    },
    {
      city: '四川',
      pici: ['本科批B段', '高职专科批'],
    },
    {
      city: '广东',
      pici: ['本科普通批', '高职专科批'],
    },
    {
      city: '陕西',
      pici: ['本科批', '高职专科批'],
    },
    {
      city: '甘肃',
      pici: ['本科批(C段)', '高职专科批'],
    },
    {
      city: '海南',
      pici: ['本科批', '专科批'],
    },
    {
      city: '内蒙古',
      pici: ['本科批', '高职专科批'],
    },
    {
      city: '青海',
      pici: ['本科批', '高职专科批'],
    },
    {
      city: '云南',
      pici: ['本科批B段', '高职专科批'],
    },
    {
      city: '贵州',
      pici: ['本科普通批', '高职专科批'],
    },
    {
      city: '宁夏',
      pici: ['本科批B段', '高职专科批'],
    },
    {
      city: '新疆',
      pici: ['本科一批', '本科二批', '专科批'],
    },
    {
      city: '西藏',
      pici: ['暂无'],
    },
  ];

  // 学科信息
  #subjects = [
    {
      name: '物理;化学;生物;历史;地理;政治',
      province: '北京',
      zongfen: '750',
      zaixuankemu: '',
      zhuankezongfen: '450',
      tianbaopici: '本科批;专科批',
    },
    {
      name: '物理;化学;生物;历史;地理;政治',
      province: '上海',
      zongfen: '660',
      zaixuankemu: '',
      zhuankezongfen: '450',
      tianbaopici: '本科批;专科批',
    },
    {
      name: '物理;化学;生物;历史;地理;政治',
      province: '天津',
      zongfen: '750',
      zaixuankemu: '',
      zhuankezongfen: '450',
      tianbaopici: '本科批;专科批',
    },
    {
      name: '物理;历史',
      province: '重庆',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;化学;生物;历史;地理;政治',
      province: '山东',
      zongfen: '750',
      zaixuankemu: '',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '山西',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '河南',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '河北',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '湖北',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '湖南',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '江西',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '650',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '辽宁',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '吉林',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '黑龙江',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '江苏',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;化学;生物;历史;地理;政治;技术',
      province: '浙江',
      zongfen: '750',
      zaixuankemu: '',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '安徽',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '福建',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '广东',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '广西',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '四川',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '陕西',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '甘肃',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;化学;生物;历史;地理;政治',
      province: '海南',
      zongfen: '900',
      zaixuankemu: '',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '贵州',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '内蒙古',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '云南',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '青海',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '物理;历史',
      province: '宁夏',
      zongfen: '750',
      zaixuankemu: '生物;化学;政治;地理',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '理科;文科',
      province: '新疆',
      zongfen: '750',
      zaixuankemu: '',
      zhuankezongfen: '',
      tianbaopici: '',
    },
    {
      name: '理科;文科',
      province: '西藏',
      zongfen: '750',
      zaixuankemu: '',
      zhuankezongfen: '',
      tianbaopici: '',
    },
  ];

  // 热门城市和省份
  #hotcities = [
    {
      title: '一线城市',
      type: 'city',
      linkId: 'gxyx',
      list: ['北京', '上海', '广州', '深圳'],
    },
    {
      title: '新一线城市',
      type: 'city',
      linkId: 'gxxyx',
      list: [
        '成都',
        '杭州',
        '重庆',
        '西安',
        '苏州',
        '武汉',
        '南京',
        '天津',
        '郑州',
        '长沙',
        '东莞',
        '佛山',
        '宁波',
        '青岛',
        '沈阳',
      ],
    },
    {
      title: '省份',
      type: 'province',
      linkId: 'gxqg',
      list: [
        '北京',
        '上海',
        '天津',
        '重庆',
        '山东',
        '山西',
        '河南',
        '河北',
        '湖北',
        '湖南',
        '江西',
        '辽宁',
        '吉林',
        '黑龙江',
        '江苏',
        '浙江',
        '安徽',
        '福建',
        '广东',
        '广西',
        '四川',
        '陕西',
        '甘肃',
        '海南',
        '贵州',
        '内蒙古',
        '云南',
        '青海',
        '宁夏',
        '新疆',
        '西藏',
      ],
    },
  ];

  // 专业信息
  #majors = {
    本科: [
      {
        subject: '哲学',
        major: '哲学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '经济学',
        major: '经济学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '经济学',
        major: '财政学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '经济学',
        major: '金融学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '经济学',
        major: '经济与贸易类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '法学',
        major: '法学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '法学',
        major: '政治学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '法学',
        major: '社会学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '法学',
        major: '民族学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '法学',
        major: '马克思主义理论类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '法学',
        major: '公安学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '教育学',
        major: '教育学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '教育学',
        major: '体育学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '文学',
        major: '中国语言文学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '文学',
        major: '外国语言文学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '文学',
        major: '新闻传播学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '历史学',
        major: '历史学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '理学',
        major: '数学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '理学',
        major: '物理学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '理学',
        major: '化学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '理学',
        major: '天文学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '理学',
        major: '地理科学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '理学',
        major: '大气科学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '理学',
        major: '海洋科学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '理学',
        major: '地球物理学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '理学',
        major: '地质学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '理学',
        major: '生物科学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '理学',
        major: '心理学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '理学',
        major: '统计学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '力学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '机械类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '仪器类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '材料类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '能源动力类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '电气类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '电子信息类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '自动化类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '计算机类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '土木类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '水利类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '测绘类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '化工与制药类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '地质类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '矿业类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '纺织类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '轻工类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '交通运输类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '海洋工程类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '航空航天类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '兵器类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '核工程类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '农业工程类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '林业工程类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '环境科学与工程类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '生物医学工程类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '食品科学与工程类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '建筑类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '安全科学与工程类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '生物工程类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '工学',
        major: '公安技术类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '农学',
        major: '植物生产类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '农学',
        major: '自然保护与环境生态类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '农学',
        major: '动物生产类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '农学',
        major: '动物医学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '农学',
        major: '林学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '农学',
        major: '水产类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '农学',
        major: '草学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '医学',
        major: '基础医学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '医学',
        major: '临床医学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '医学',
        major: '口腔医学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '医学',
        major: '公共卫生与预防医学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '医学',
        major: '中医学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '医学',
        major: '中西医结合类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '医学',
        major: '药学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '医学',
        major: '中药学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '医学',
        major: '法医学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '医学',
        major: '医学技术类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '医学',
        major: '护理学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '管理学',
        major: '管理科学与工程类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '管理学',
        major: '工商管理类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '管理学',
        major: '农业经济管理类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '管理学',
        major: '公共管理类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '管理学',
        major: '图书情报与档案管理类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '管理学',
        major: '物流管理与工程类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '管理学',
        major: '工业工程类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '管理学',
        major: '电子商务类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '管理学',
        major: '旅游管理类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '艺术学',
        major: '艺术学理论类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '艺术学',
        major: '音乐与舞蹈学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '艺术学',
        major: '戏剧与影视学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '艺术学',
        major: '美术学类',
        type: 2,
        typeName: '本科',
      },
      {
        subject: '艺术学',
        major: '设计学类',
        type: 2,
        typeName: '本科',
      },
    ],
    专科: [
      {
        subject: '农林牧渔大类',
        major: '农业类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '农林牧渔大类',
        major: '林业类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '农林牧渔大类',
        major: '畜牧业类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '农林牧渔大类',
        major: '渔业类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '资源环境与安全大类',
        major: '资源勘查类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '资源环境与安全大类',
        major: '测绘地理信息类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '资源环境与安全大类',
        major: '石油与天然气类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '资源环境与安全大类',
        major: '煤炭类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '资源环境与安全大类',
        major: '金属与非金属矿类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '资源环境与安全大类',
        major: '气象类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '资源环境与安全大类',
        major: '环境保护类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '资源环境与安全大类',
        major: '安全类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '能源动力与材料大类',
        major: '电力技术类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '能源动力与材料大类',
        major: '热能与发电工程类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '能源动力与材料大类',
        major: '新能源发电工程类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '能源动力与材料大类',
        major: '有色金属材料类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '能源动力与材料大类',
        major: '非金属材料类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '能源动力与材料大类',
        major: '建筑材料类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '土木建筑大类',
        major: '建筑设计类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '土木建筑大类',
        major: '城乡规划与管理类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '土木建筑大类',
        major: '土建施工类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '土木建筑大类',
        major: '建筑设备类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '土木建筑大类',
        major: '建设工程管理类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '土木建筑大类',
        major: '市政工程类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '土木建筑大类',
        major: '房地产类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '水利大类',
        major: '水文水资源类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '水利大类',
        major: '水利工程与管理类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '水利大类',
        major: '水土保持与水环境类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '装备制造大类',
        major: '机械设计制造类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '装备制造大类',
        major: '机电设备类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '装备制造大类',
        major: '轨道装备类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '装备制造大类',
        major: '船舶与海洋工程装备类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '装备制造大类',
        major: '航空装备类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '交通运输大类',
        major: '道路运输类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '装备制造大类',
        major: '汽车制造类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '生物与化工大类',
        major: '生物技术类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '生物与化工大类',
        major: '化工技术类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '轻工纺织大类',
        major: '轻化工类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '轻工纺织大类',
        major: '包装类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '轻工纺织大类',
        major: '印刷类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '轻工纺织大类',
        major: '纺织服装类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '文化艺术大类',
        major: '艺术设计类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '食品药品与粮食大类',
        major: '食品类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '食品药品与粮食大类',
        major: '药品与医疗器械类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '交通运输大类',
        major: '铁道运输类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '财经商贸大类',
        major: '物流类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '交通运输大类',
        major: '水上运输类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '交通运输大类',
        major: '航空运输类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '交通运输大类',
        major: '管道运输类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '交通运输大类',
        major: '城市轨道交通类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '交通运输大类',
        major: '邮政类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '电子与信息大类',
        major: '集成电路类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '电子与信息大类',
        major: '通信类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '医药卫生大类',
        major: '中医药类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '医药卫生大类',
        major: '护理类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '医药卫生大类',
        major: '眼视光类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '医药卫生大类',
        major: '康复治疗类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '医药卫生大类',
        major: '公共卫生与卫生管理类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '医药卫生大类',
        major: '健康管理与促进类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '财经商贸大类',
        major: '财政税务类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '财经商贸大类',
        major: '金融类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '财经商贸大类',
        major: '财务会计类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '财经商贸大类',
        major: '统计类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '财经商贸大类',
        major: '经济贸易类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '旅游大类',
        major: '旅游类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '旅游大类',
        major: '餐饮类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '文化艺术大类',
        major: '表演艺术类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '文化艺术大类',
        major: '民族文化艺术类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '文化艺术大类',
        major: '文化服务类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '新闻传播大类',
        major: '新闻出版类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '新闻传播大类',
        major: '广播影视类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '教育与体育大类',
        major: '教育类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '教育与体育大类',
        major: '语言类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '教育与体育大类',
        major: '体育类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '公安与司法大类',
        major: '公安管理类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '公安与司法大类',
        major: '侦查类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '公安与司法大类',
        major: '法律实务类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '公安与司法大类',
        major: '法律执行类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '公安与司法大类',
        major: '司法技术类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '公安与司法大类',
        major: '安全防范类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '公共管理与服务大类',
        major: '公共事业类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '公共管理与服务大类',
        major: '公共服务类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '能源动力与材料大类',
        major: '黑色金属材料类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '水利大类',
        major: '水利水电设备类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '食品药品与粮食大类',
        major: '粮食类',
        type: 1,
        typeName: '专科',
      },
      {
        subject: '公共管理与服务大类',
        major: '文秘类',
        type: 1,
        typeName: '专科',
      },
    ],
  };

  selectedProvince = '上海'; // 选中的省份
  score = ''; // 高考分数
  selectedSubjects = []; // 选中的科目
  selectedBakSubjects = []; // 选中的备选科目
  selectedPriority = ''; // 选科优先级
  selectedPici = ''; // 选中的批次
  selectedGraduations = []; // 选中的毕业方式
  selectedPreferredCity = ''; // 偏好城市

  // 专业
  selectedClassify = '综合'; // 选中的学科分类

  selectedDiscipline = '工学'; // 选中的学科
  selectedMajor = []; // 选中的专业

  constructor() {
    makeAutoObservable(this);
  }

  get provinces() {
    return this.#provinces.map(item => item.city);
  }

  /**
   * 获取科目,如：物理;化学;生物;历史;地理;政治
   * @param {*} province
   * @returns
   */
  getSubjects() {
    let matchedProv = this.#subjects.filter(
      subject => subject.province === this.selectedProvince
    );
    if (!matchedProv || matchedProv.length == 0) {
      matchedProv = this.#subjects[0];
    } else {
      matchedProv = matchedProv[0];
    }

    const result = {
      ...matchedProv,
      name: matchedProv.name.split(';').filter(item => item && item.length > 0),
      zaixuankemu: matchedProv.zaixuankemu
        .split(';')
        .filter(item => item && item.length > 0),
    };
    if (result.zaixuankemu.length === 0) {
      result.title1 = '高考科目';
      result.title2 = '';
      result.firstCount = 3; // 高考科目数
      result.secondCount = 0; // 选科目数
    } else {
      result.title1 = '首选科目';
      result.title2 = '再选科目';
      result.firstCount = 1; // 高考科目数
      result.secondCount = 2; // 选科目数
    }

    return result;
  }

  getPicies() {
    const matchedProv = this.#provinces.filter(
      province => province.city === this.selectedProvince
    );
    if (!matchedProv || matchedProv.length == 0) {
      return [];
    }
    return matchedProv[0].pici;
  }

  /**
   * 取学科分类
   * @param {} type
   * @returns
   */
  getDisciplines(type = 2) {
    const subjects = this.#majors[type === 1 ? '专科' : '本科'].map(
      major => major.subject
    );
    const classifies = new Set(subjects);
    let result = {};
    classifies.forEach(classify => {
      if (!result[classify]) {
        result[classify] = [];
      }
      const founded = this.#majors[type === 1 ? '专科' : '本科'].filter(
        major => major.subject === classify
      );
      result[classify] = [
        ...result[classify],
        ...founded.map(major => major.major),
      ];
    });
    return result;
  }

  getHotCities() {
    let cities = [];
    this.#hotcities.forEach(item => {
      if (item.type === 'city') {
        cities = cities.concat(item.list);
      } else if (item.type === 'province') {
        cities = cities.concat(item.list);
      }
    });

    const list = new Set(cities);
    return [...list];
  }

  setScore(score) {
    runInAction(() => {
      this.score = score;
    });
  }

  setProvince(province) {
    runInAction(() => {
      this.selectedProvince = province;
    });
  }

  setSubjects(subjects) {
    runInAction(() => {
      this.selectedSubjects = subjects;
    });
  }

  toggleSubject(subject) {
    runInAction(() => {
      if (this.selectedSubjects.includes(subject)) {
        this.selectedSubjects = this.selectedSubjects.filter(
          item => item !== subject
        );
      } else {
        this.selectedSubjects.push(subject);
      }
    });
  }
  isSelectedSubject(subject) {
    return this.selectedSubjects.includes(subject);
  }

  toggleBakSubject(subject) {
    runInAction(() => {
      if (this.selectedBakSubjects.includes(subject)) {
        this.selectedBakSubjects = this.selectedBakSubjects.filter(
          item => item !== subject
        );
      } else {
        this.selectedBakSubjects.push(subject);
      }
    });
  }
  isSelectedBakSubject(subject) {
    return this.selectedBakSubjects.includes(subject);
  }

  setPici(pici) {
    runInAction(() => {
      this.selectedPici = pici;
    });
  }

  setPriority(priority) {
    runInAction(() => {
      this.selectedPriority = priority;
    });
  }

  addGraduation(graduation) {
    runInAction(() => {
      this.selectedGraduations.push(graduation);
    });
  }

  removeGraduation(graduation) {
    runInAction(() => {
      this.selectedGraduations = this.selectedGraduations.filter(
        item => item !== graduation
      );
    });
  }
  isSelectedGraduation(graduation) {
    return this.selectedGraduations.includes(graduation);
  }

  setPreferredCity(city) {
    runInAction(() => {
      this.selectedPreferredCity = city;
    });
  }

  setClassify(classify) {
    runInAction(() => {
      this.selectedClassify = classify;
    });
  }
  
  setDiscipline(discipline) {
    const currentDisciplines = this.getDisciplines();
    if (!currentDisciplines[discipline]) {
      console.warn(`Discipline ${discipline} not found.`);
      return;
    }
    runInAction(() => {
      this.selectedDiscipline = discipline;
      this.selectedMajor = [];
    });
  }
  toggleMajor(major) {
    runInAction(() => {
      if (this.selectedMajor.includes(major)) {
        this.selectedMajor = this.selectedMajor.filter(item => item !== major);
      } else {
        this.selectedMajor.push(major);
      }
    });
  }

  patchData({ cid, msg_id, plan_step_id, data = {} }) {
    const param = {
      cid,
      msg_id,
      plan_step_id,
      data,
    };
    return request
      .post('ai_agent/event/patch', param, {
        dataIsJson: true,
      })
      .then(res => {
        console.log(res);
      });
  }
}

const gaokaoStore = new Store();
export default gaokaoStore;
